import { updateSearchParam } from '@fukuri-admins/utils/common';
import { useSearchParams } from 'react-router-dom';
import { TableFooterPresentation } from '../presentations';

type PresentationProps = React.ComponentProps<typeof TableFooterPresentation>;
type Args = {
  totalPage: number;
  onPageChange: (newPage: number) => void;
};

type IUseTableFooter = (props: Args) => {
  data: {
    currentPage: PresentationProps['currentPage'];
  };
  actions: {
    handleFirstPageButtonClick: PresentationProps['handleFirstPageButtonClick'];
    handleBackButtonClick: PresentationProps['handleBackButtonClick'];
    handleNextButtonClick: PresentationProps['handleNextButtonClick'];
    handleLastPageButtonClick: PresentationProps['handleLastPageButtonClick'];
  };
};

export const useTableFooter: IUseTableFooter = ({ totalPage, onPageChange }) => {
  const [filterParams, setFilterParams] = useSearchParams();

  // クエリパラメーターからpageのkeyの値を取得する.もし値がない場合は1を返す
  const pageNumber = filterParams.get('page') ? Number(filterParams.get('page')) : 1;
  // ページ番号が総ページ数より大きい場合は総ページ数、1より小さい場合は1を返す
  const currentPageNumber = pageNumber > totalPage ? totalPage : pageNumber < 1 ? 1 : pageNumber;

  // ページ番号を更新して、onPageChangeを呼び出す
  const updateFilterParams = (key: string, value: number) => {
    setFilterParams(updateSearchParam(filterParams, key, value.toString()));
    onPageChange(value);
  };

  const handleFirstPageButtonClick = (): void => updateFilterParams('page', 1);
  const handleBackButtonClick = (): void => updateFilterParams('page', currentPageNumber - 1);
  const handleNextButtonClick = (): void => updateFilterParams('page', currentPageNumber + 1);
  const handleLastPageButtonClick = (): void => updateFilterParams('page', totalPage);

  return {
    data: {
      currentPage: currentPageNumber,
    },
    actions: {
      handleFirstPageButtonClick,
      handleBackButtonClick,
      handleNextButtonClick,
      handleLastPageButtonClick,
    },
  };
};
